import React from "react"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import { IUIUser } from "../../../models"
import EmployeeInfoTable from "../../employee/EmployeeInfoTable"
interface IProps {
    globalPunchEmployees: IUIUser[]
    handleClose(): void
}

const GlobalPunchEmployeeInfoDialog: React.SFC<IProps> = (props: IProps) => {
    return (
        <Dialog
            modal
            actions={[
                <FlatButton
                    label={strings.OK}
                    primary
                    keyboardFocused
                    onClick={props.handleClose}
                />
            ]}
            open
            onRequestClose={props.handleClose}
            autoScrollBodyContent
        >
            <EmployeeInfoTable
                users={props.globalPunchEmployees}
            />
        </Dialog>
    )
}

export default GlobalPunchEmployeeInfoDialog
